// DS: DS2.6.1
import React from 'react';
import ToggleButton from '../ToggleButton/ToggleButton';
import s from './ToggleButtonGroup.scss';
const ToggleButtonGroup = ({ buttons, value: selectedValue, disabled, onChange })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, buttons.map(({ value, href, tooltipText, ariaLabel, icon, biData }, index)=>/*#__PURE__*/ React.createElement(ToggleButton, {
            key: index,
            activated: value === selectedValue,
            tooltipText: tooltipText,
            "aria-label": ariaLabel,
            icon: icon,
            disabled: disabled,
            biData: biData,
            href: href,
            onClick: ()=>{
                if (value !== selectedValue && onChange) {
                    onChange(value);
                }
            }
        })));
};
ToggleButtonGroup.displayName = 'ToggleButtonGroup';
export default ToggleButtonGroup;
